export default __webpack_public_path__ + "static/media/cargo-nfts.3b9221d6.png";